"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffMinutes = exports.now = exports.sleep = exports.timeSpan = void 0;
const timeSpan = (start, rand) => {
    const sec = 1000;
    const min = 60 * sec;
    const hour = 60 * min;
    const day = 24 * hour;
    const toMsec = (ts) => {
        if (!ts) {
            return 0;
        }
        ts = ts.toString();
        let time = 0;
        ts.split(/(\d+\D+)/).filter((f) => f !== '').forEach((e) => {
            const t = parseInt(e);
            switch (true) {
                case e.includes('day') || e.includes('d'):
                    time += t * day;
                    break;
                case e.includes('hour') || e.includes('h'):
                    time += t * hour;
                    break;
                case e.includes('min') || e.includes('m'):
                    time += t * min;
                    break;
                case e.includes('sec') || e.includes('s'):
                    time += t * sec;
                    break;
                default:
                    break;
            }
        });
        return time;
    };
    return toMsec(start) + toMsec(rand) * Math.random();
};
exports.timeSpan = timeSpan;
const sleep = (time) => {
    return new Promise((resolve) => { setTimeout(resolve, exports.timeSpan(time)); });
};
exports.sleep = sleep;
const now = () => new Date().toJSON().replace('T', ' ').replace('Z', '');
exports.now = now;
const diffMinutes = (dt2, dt1) => Math.abs(Math.round((dt2.getTime() - dt1.getTime()) / 60000));
exports.diffMinutes = diffMinutes;
//# sourceMappingURL=time.js.map